var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-tile',{attrs:{"data-testid":"itemRow","exact":""},on:{"click":function($event){return _vm.$emit('clicked', $event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }